/**************************************************
 * Nombre:       Seccion_Pedidos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATO, CASILLA_FECHA_DATOS,
    CASILLA_FUNCION_MONEDA,
    CASILLA_TEXTO, CASILLA_TITULO_DATO, CASILLA_TITULO_FUNCION_MONEDA, CASILLA_TITULO_MONEDA
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React, {useEffect, useRef, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import {ESTADOPEDIDO, ESTADOSPEDIDOS} from "../../Constantes";
import Dialogo_Pedido from "../Dialogos/Dialogo_Pedido";
import {obtenerTotal} from "../../CodNegocio/obtenerTotal";
import {useObtenerAlto} from "../../Modulo_Graficas/Hooks/useObtenerAlto";
import Tarjeta_Titulo_Subtitulo_Grafica_Larga
    from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Titulo_Subtitulo_Grafica_Larga";
import Linea_Limpia from "../../Modulo_Graficas/Graficas/Linea_Limpia";
import Barras_Horizontales_Nombre from "../../Modulo_Graficas/Graficas/Barras_Horizontales_Nombre";
import {arrConteoColMesesAtras} from "../../Servicios/BD/Contadores_Arr/arrConteoColMesesAtras";
import {arrConteoColPropiedadEstados} from "../../Servicios/BD/Contadores_Arr/arrConteoColPropiedadEstados";


const Seccion_Pedidos = () => {
    const refe = useRef()
    const altoGraficas = 190
    const {alto} = useObtenerAlto({contenedor: refe})
    const {props, setData, setNumeroFilas, cargarNuevamente} = useObtenerColleccionTabla2025({coleccion: 'pedidos'})
    const [numPedidos, setNumPedidos] = useState([])
    const [locales, setLocales] = useState([])
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Pedido,
        titulo: 'Detalles del pedido',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)
        }
    }


    const obtenerDatos = async () => {


        let doxPedidos = await arrConteoColMesesAtras({coleccion: 'pedidos', mesesAtras: 12})
        setNumPedidos(doxPedidos)

        let locales_ = await arrConteoColPropiedadEstados({
            coleccion: 'pedidos',
            propiedad: 'estado',
            arrEstados: ESTADOPEDIDO.map((it) => it.nombre).reverse(),
        })

        setLocales(locales_)


    }


    useEffect(() => {
        obtenerDatos().then((data) => {
        })
    }, []);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <Grid ref={refe} container size={{xs: 12, sm: 12, md: 8}}>
                    <Tarjeta_Titulo_Subtitulo_Grafica_Larga
                        titulo={'Pedidos'}
                        subtitulo={'Ultimos 12 meses'}
                        Grafica={Linea_Limpia}
                        marginTop={12}
                        height={altoGraficas}
                        series={
                            [
                                {
                                    name: new Date().getFullYear(),
                                    data: numPedidos.map((it) => it.cantidad)

                                }
                            ]
                        }
                        labels={numPedidos.map((it) => it.nombre)}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 3, md: 4}}
                      sx={{height: alto}}
                >
                    <Tarjeta_Titulo_Subtitulo_Grafica_Larga
                        titulo={'Segun'}
                        subtitulo={'local asignado'}
                        Grafica={Barras_Horizontales_Nombre}
                        marginTop={20}
                        height={altoGraficas - 40}
                        series={
                            [{
                                name: 'locales',
                                data: locales.map((e) => e.cantidad)
                            }]
                        }

                        labels={ESTADOPEDIDO.map((it) => it.nombre.substring(0, 3))}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista pedidos'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                       // clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                        //ComponenteInferior={ExportadorDatos}

                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Pedidos

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]


const datosCabecera = [
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedades: ['consecutivo','nombres', 'apellidos'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Ciudad',
        direccion: 'left',
        propiedad: 'ciudad',
        titulo:"departamento",
        tipo: CASILLA_TITULO_DATO

    },
    {
        nombre: 'Pago',
        direccion: 'left',
        propiedad: 'valorPagado',
        titulo: 'estadoPago',
        tipo: CASILLA_TITULO_MONEDA

    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSPEDIDOS
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]